export const PLACE_OF_BIRTH = [
  "JAKARTA",
  "KEP SERIBU",
  "TANGERANG",
  "TANGSEL",
  "BOGOR",
  "KOTA BOGOR",
  "DEPOK",
  "BEKASI",
  "MEDAN",
  "BAGE",
  "SIGUMPOLAN",
  "DELI SERDANG",
  "TEBING TINGGI",
  "BINJAI",
  "LANGKAT",
  "PAYA PERUPUK",
  "TANJUNG PURA",
  "SERDANG BEDAGAI",
  "UJUNG RAMBUNG",
  "TANJUNG BERINGIN",
  "PEMATANGSIANTAR",
  "SIMALUNGUN",
  "ASAHAN",
  "AEK LOBA",
  "RAWA SARI",
  "BATU BARA",
  "TANJUNG BALAI",
  "LABUHAN BATU",
  "LABUHANBATU UTA",
  "LABUHANBATU SEL",
  "KARO",
  "DAIRI",
  "PAKPAK BHARAT",
  "TOBA SAMOSIR",
  "SITUMPOL",
  "TANGGA BATU",
  "SAMOSIR",
  "TAPANULI UTARA",
  "HUMBAHAS",
  "PARRIAAN",
  "SITANGKUBANG",
  "SIBOLGA",
  "TAPANULI TENGAH",
  "PADANG SIDEMPUA",
  "TAPANULI SEL",
  "PADANG LAWAS UT",
  "PADANG LAWAS",
  "GUNUNGSITOLI",
  "NIAS BARAT",
  "NIAS UTARA",
  "NIAS",
  "NIAS SELATAN",
  "MANDAILING NATA",
  "BANDA ACEH",
  "ACEH BESAR",
  "SABANG",
  "ACEH BARAT",
  "ACEH JAYA",
  "NAGAN RAYA",
  "ACEH SELATAN",
  "ACEH BARAT DAYA",
  "SIMEULUE",
  "PIDIE",
  "PIDIE JAYA",
  "BIREUEN",
  "LHOKSEUMAWE",
  "ACEH UTARA",
  "LANGSA",
  "ACEH TIMUR",
  "ACEH TAMIANG",
  "ACEH TENGAH",
  "BENER MERIAH",
  "ACEH TENGGARA",
  "GAYO LUES",
  "SUBULUSSALAM",
  "ACEH SINGKIL",
  "PADANG",
  "MAHAKARYA",
  "BATUSANGKAR",
  "KEP MENTAWAI",
  "PARIAMAN",
  "PADANG PARIAMAN",
  "PESISIR SELATAN",
  "BUKITTINGGI",
  "AGAM",
  "PAYAKUMBUH",
  "LIMA PULUH KOTA",
  "PANDAM GADANG",
  "BUKIT APIT",
  "KOTO MALINTANG",
  "PASAMAN",
  "PASAMAN BARAT",
  "SIMPANG TIGA",
  "SIMPANG EMPAT",
  "PADANG PANJANG",
  "TANAH DATAR",
  "SOLOK",
  "SAWAH LUNTO",
  "SIJUNJUNG",
  "DHARMASRAYA",
  "SOLOK SELATAN",
  "PEKANBARU",
  "PELALAWAN",
  "KAMPAR",
  "ROKAN HULU",
  "SIAK",
  "BENGKALIS",
  "DURI",
  "KEP MERANTI",
  "DUMAI",
  "ROKAN HILIR",
  "PANIPAHAN",
  "SIMPANG KANAN",
  "BAGAN SIAPIAPI",
  "TANJUNG PINANG",
  "BINTAN",
  "INDRAGIRI HILIR",
  "INDRAGIRI HULU",
  "BATAM",
  "KUANSING",
  "KARIMUN",
  "NATUNA",
  "KEP ANAMBAS",
  "LINGGA",
  "PALEMBANG",
  "CENGAL",
  "SUKAMENANG",
  "OKI",
  "OGAN ILIR",
  "MUSI BANYUASIN",
  "MUSI RAWAS",
  "MUARA RUPIT",
  "BANYUASIN",
  "PRABUMULIH",
  "MUARA ENIM",
  "TANJUNG SERIAN",
  "SUBAN JERIJI",
  "LAHAT",
  "EMPAT LAWANG",
  "PAGAR ALAM",
  "LUBUK LINGGAU",
  "OKU",
  "OKU TIMUR",
  "OGAN KOMERING ULU",
  "MARTAPURA",
  "OKU SELATAN",
  "PANGKAL PINANG",
  "BANGKA",
  "SELINYU",
  "SUNGAILIAT",
  "BANGKA BARAT",
  "BELITUNG",
  "BELITUNG TIMUR",
  "BANGKA TENGAH",
  "BANGKA SELATAN",
  "METRO",
  "LAMPUNG TENGAH",
  "GAYAU SAKTI",
  "SINARSARI",
  "SRIDADI",
  "LAMPUNG TIMUR",
  "TULANGBAWANG BA",
  "LAMPUNG UTARA",
  "KOTA BUMI",
  "SEMULI JAYA",
  "TULANG BAWANG",
  "MESUJI",
  "WAY KANAN",
  "LAMPUNG BARAT",
  "PESISIR BARAT",
  "BANDAR LAMPUNG",
  "TANJUNG KARANG",
  "WARINGIN SARI",
  "LAMPUNG SELATAN",
  "PALAS",
  "BANJAR NEGERI",
  "PESAWARAN",
  "PRINGSEWU",
  "TANGGAMUS",
  "TALANG PADANG",
  "AIR ABANG",
  "BABAKAN",
  "KARANG SARI",
  "JAMBI",
  "MUARO JAMBI",
  "TANJAB BARAT",
  "TANJAB TIMUR",
  "BATANG HARI",
  "SUNGAIPENUH",
  "KERINCI",
  "BUNGO",
  "TEBO",
  "MERANGIN",
  "SAROLANGUN",
  "BENGKULU",
  "BENGKULU UTARA",
  "BENGKULU TENGAH",
  "BENGKULU SEL",
  "MUKO MUKO",
  "SELUMA",
  "KAUR",
  "REJANG LEBONG",
  "LEBONG",
  "KEPAHIANG",
  "BANDUNG",
  "BANDUNG BARAT",
  "CIMAHI",
  "PURWAKARTA",
  "SUBANG",
  "KARAWANG",
  "SERANG",
  "PANDEGLANG",
  "LEBAK",
  "CILEGON",
  "SUKABUMI",
  "CIANJUR",
  "GARUT",
  "CIREBON",
  "KOTA CIREBON",
  "INDRAMAYU",
  "SUMEDANG",
  "MAJALENGKA",
  "KUNINGAN",
  "TASIKMALAYA",
  "CIAMIS",
  "PANGANDARAN",
  "BANJAR",
  "SEMARANG",
  "SALATIGA",
  "PEKALONGAN",
  "BATANG",
  "KENDAL",
  "TEGAL",
  "BREBES",
  "PEMALANG",
  "BANYUMAS",
  "CILACAP",
  "PURBALINGGA",
  "BANJARNEGARA",
  "PURWOREJO",
  "KEBUMEN",
  "YOGYAKARTA",
  "BANTUL",
  "SLEMAN",
  "KULON PROGO",
  "GUNUNG KIDUL",
  "MAGELANG",
  "TEMANGGUNG",
  "WONOSOBO",
  "SURAKARTA",
  "SUKOHARJO",
  "KARANGANYAR",
  "SRAGEN",
  "BOYOLALI",
  "KLATEN",
  "WONOGIRI",
  "GROBOGAN",
  "BLORA",
  "PATI",
  "REMBANG",
  "KUDUS",
  "JEPARA",
  "DEMAK",
  "SURABAYA",
  "GRESIK",
  "SIDOARJO",
  "MOJOKERTO",
  "JOMBANG",
  "BOJONEGORO",
  "LAMONGAN",
  "TUBAN",
  "MADIUN",
  "MAGETAN",
  "NGAWI",
  "PONOROGO",
  "PACITAN",
  "KEDIRI",
  "NGANJUK",
  "MALANG",
  "BATU",
  "BLITAR",
  "TULUNGAGUNG",
  "TRENGGALEK",
  "PASURUAN",
  "PROBOLINGGO",
  "LUMAJANG",
  "JEMBER",
  "BONDOWOSO",
  "SITUBONDO",
  "BANYUWANGI",
  "BANGKALAN",
  "SAMPANG",
  "PAMEKASAN",
  "SUMENEP",
  "BANJARMASIN",
  "BARITO KUALA",
  "BANJARBARU",
  "TANAH LAUT",
  "TAPIN",
  "HULU SUNGAI SEL",
  "HULU SUNGAI TEN",
  "HULU SUNGAI UTA",
  "TABALONG",
  "BALANGAN",
  "KOTABARU",
  "TANAH BUMBU",
  "PALANGKA RAYA",
  "KAPUAS",
  "BARITO TIMUR",
  "BARITO SELATAN",
  "BARITO UTARA",
  "MURUNG RAYA",
  "KOTAWARINGIN BA",
  "LAMANDAU",
  "SUKAMARA",
  "SERUYAN",
  "KOTAWARINGIN TI",
  "KATINGAN",
  "GUNUNG MAS",
  "PULANG PISAU",
  "SAMARINDA",
  "KUKAR",
  "BONTANG",
  "KUTAI TIMUR",
  "KUTAI BARAT",
  "BALIKPAPAN",
  "PENAJAM PASER U",
  "PASER",
  "TARAKAN",
  "TANA TIDUNG",
  "MALINAU",
  "BULUNGAN",
  "BERAU",
  "NUNUKAN",
  "PONTIANAK",
  "KUBU RAYA",
  "SANGGAU",
  "SINTANG",
  "KAPUAS HULU",
  "KETAPANG",
  "KAYONG UTARA",
  "SINGKAWANG",
  "SAMBAS",
  "BENGKAYANG",
  "LANDAK",
  "SEKADAU",
  "MELAWI",
  "DENPASAR",
  "BADUNG",
  "GIANYAR",
  "BANGLI",
  "KLUNGKUNG",
  "KARANGASEM",
  "BULELENG",
  "TABANAN",
  "JEMBRANA",
  "GUMBRIH",
  "MANGGIS SARI",
  "KOTA NEGARA",
  "MATARAM",
  "LOMBOK BARAT",
  "LOMBOK UTARA",
  "LOMBOK TENGAH",
  "LOMBOK TIMUR",
  "TIBU TANGKOK",
  "DASAN BEMBEK",
  "SURALAGA",
  "BIMA",
  "DOMPU",
  "SUMBAWA",
  "TERUJUNG",
  "MARGA",
  "SUMBAWA BESAR",
  "SUMBAWA BARAT",
  "KUPANG",
  "SABU RAIJUA",
  "TIMOR TENG SEL",
  "TIMOR TENG UTA",
  "BELU",
  "ALOR",
  "ROTE NDAO",
  "ENDE",
  "SIKKA",
  "FLORES TIMUR",
  "NGADA",
  "NAGEKEO",
  "MANGGARAI",
  "MANGGARAI TIMUR",
  "LEMBATA",
  "MANGGARAI BARAT",
  "SUMBA TIMUR",
  "SUMBA BARAT",
  "SUMBA BD",
  "SUMBA TENGAH",
  "MAKASSAR",
  "UJUNG PANDANG",
  "WALASIHO",
  "GOWA",
  "BONE",
  "MAROS",
  "PANGKAJENE KEP",
  "BARRU",
  "SOPPENG",
  "WAJO",
  "PAREPARE",
  "PINRANG",
  "POLEWALI MANDAR",
  "MAMUJU",
  "MAMASA",
  "MAJENE",
  "MAMUJU UTARA",
  "SIDRAP",
  "SINJAI",
  "ENREKANG",
  "TANA TORAJA",
  "TORAJA UTARA",
  "LUWU UTARA",
  "PALOPO",
  "LUWU",
  "LUWU TIMUR",
  "TAKALAR",
  "JENEPONTO",
  "BANTAENG",
  "BULUKUMBA",
  "KEP SELAYAR",
  "KENDARI",
  "KONAWE",
  "KONAWE UTARA",
  "KONAWE SELATAN",
  "KOLAKA",
  "MUNA",
  "BUTON UTARA",
  "BAU-BAU",
  "BUTON",
  "BOMBANA",
  "WAKATOBI",
  "KOLAKA UTARA",
  "PALU",
  "SIGI",
  "DONGGALA",
  "PARIGI MOUTONG",
  "TOLI-TOLI",
  "BUOL",
  "POSO",
  "TOJO UNA-UNA",
  "BANGGAI",
  "BANGGAI KEP",
  "MOROWALI",
  "MANADO",
  "MINAHASA SEL",
  "MINAHASA",
  "MINAHASA UTARA",
  "TOMOHON",
  "BITUNG",
  "KOTAMOBAGU",
  "BOLMONG",
  "BOLMONG UTARA",
  "BOLMONG SELATAN",
  "BOLMONG TIMUR",
  "KEP SANGIHE",
  "KEP SITARO",
  "KEP TALAUD",
  "MINAHASA TENG",
  "GORONTALO",
  "GORONTALO UTARA",
  "BOALEMO",
  "POHUWATO",
  "BONE BOLANGO",
  "AMBON",
  "MALUKU BD",
  "KEP TANIMBAR",
  "MALUKU TENGAH",
  "BURU SELATAN",
  "SERAM BAG TIMUR",
  "SERAM BAG BARAT",
  "BURU",
  "MALUKU TENGGARA",
  "TUAL",
  "KEPULAUAN ARU",
  "TERNATE",
  "HALMAHERA BARAT",
  "HALMAHERA UTARA",
  "HALMAHERA SEL",
  "PULAU MOROTAI",
  "LUSUO",
  "KEPULAUAN SULA",
  "TIDORE KEP",
  "HALMAHERA TENG",
  "HALMAHERA TIMUR",
  "BIAK NUMFOR",
  "BIAK",
  "SUPIORI",
  "KEP YAPEN",
  "WAROPEN",
  "MAMBERAMO RAYA",
  "MANOKWARI",
  "PEG ARFAK",
  "MANOKWARI SEL",
  "TELUK WONDAMA",
  "TELUK BINTUNI",
  "TAMBRAUW",
  "SORONG",
  "SORONG SELATAN",
  "MAYBRAT",
  "RAJA AMPAT",
  "FAKFAK",
  "KAIMANA",
  "PANIAI",
  "DEIYAI",
  "INTAN JAYA",
  "NABIRE",
  "DOGIYAI",
  "PUNCAK JAYA",
  "PUNCAK",
  "JAYAPURA",
  "SARMI",
  "KEEROM",
  "JAYAWIJAYA",
  "MAMBERAMO TENG",
  "LANNY JAYA",
  "TOLIKARA",
  "NDUGA",
  "YAHUKIMO",
  "PEG BINTANG",
  "YALIMO",
  "MERAUKE",
  "BOVEN DIGOEL",
  "ASMAT",
  "MAPPI",
  "MIMIKA",
];

export const POB_OTHERS = "OTHERS";
